import {ReactNode} from "react";
import {Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography} from "@mui/material";
import {FormattedMessage, MessageDescriptor} from "react-intl";
import {HasPermission} from "../../widgets";
import {Page} from "../../pages";
import {ContextFilters} from "@/context/AuthProvider";

type Props = {
    label: MessageDescriptor;
    labelExtra: ReactNode;
    addUserDialog: ReactNode;
    createRows: () => ReactNode;
    domainName: string;
};

const SharedUserManagement = ({label, labelExtra, addUserDialog, createRows, domainName}: Props) => {
    const domainContextFilter = ContextFilters.domain(domainName);

    return (
        <Page title={label} controls={labelExtra} inlineControls>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>
                                <Typography>
                                    <FormattedMessage id="userManagement.columns.name" defaultMessage="Name" />
                                </Typography>
                            </TableCell>
                            <TableCell>
                                <Typography>
                                    <FormattedMessage
                                        id="userManagement.columns.loginNames"
                                        defaultMessage="Login names"
                                    />
                                </Typography>
                            </TableCell>
                            <TableCell>
                                <Typography>
                                    <FormattedMessage id="userManagement.columns.emails" defaultMessage="Emails" />
                                </Typography>
                            </TableCell>
                            <TableCell>
                                <Typography>
                                    <FormattedMessage id="userManagement.columns.owner" defaultMessage="Owner" />
                                </Typography>
                            </TableCell>
                            <HasPermission name="add_extension" contextFilter={domainContextFilter}>
                                <TableCell align="right">
                                    <Typography>
                                        <FormattedMessage
                                            id="userManagement.columns.actions"
                                            defaultMessage="Actions"
                                        />
                                    </Typography>
                                </TableCell>
                            </HasPermission>
                        </TableRow>
                    </TableHead>
                    <TableBody>{createRows()}</TableBody>
                </Table>
            </TableContainer>
            {addUserDialog}
        </Page>
    );
};

export default SharedUserManagement;
